// Default data from database - complete cache/fallback for offline use

export const DEFAULT_SERVICES = [
  {
    "id": "fonksiyonel-tip",
    "title": "Fonksiyonel Tıp Danışmanlığı",
    "order": 1,
    "short": "Kronik hastalıkların kök nedenlerini araştırarak kişiye özel ve bütüncül tedavi yaklaşımlarıyla kalıcı sağlık dengesini hedefler",
    "icon": "Stethoscope",
    "bullets": [
      "Sindirim Sistemi: İnflamatuar Barsak Hastalığı, SİBO",
      "Kronik yorgunluk, Baş ağrısı",
      "Haşimoto Tiroiditi ve Zehirli Guatr",
      "Histamin İntoleransı",
      "Cilt Hastalıkları: Sedef Hastalığı, Kronik Ürtiker, Akne",
      "Romatizmal Eklem Hastalıkları",
      "Diğer Otoimmün hastalıklar"
    ],
    "overview": "Fonksiyonel tıp, kronik hastalıkların altında yatan kök nedenleri araştıran ve her birey için kişiye özel tedavi planları oluşturan bütüncül bir yaklaşımdır. Geleneksel tıbbın semptom odaklı tedavisinden farklı olarak, vücudu bir bütün olarak değerlendirir ve hastalığın gerçek kaynağına ulaşmayı hedefler.\n\nBeslenme, yaşam tarzı, genetik yatkınlık, çevresel faktörler ve stres düzeyi gibi pek çok değişken birlikte ele alınarak, hastanın genel sağlık durumunu iyileştirmeye yönelik kapsamlı bir plan oluşturulur.",
    "who_for": [
      "Tiroid hastalıkları (Haşimoto Tiroiditi, Zehirli Guatr) yaşayanlar",
      "Sindirim sistemi sorunları (İnflamatuar Barsak Hastalığı, SİBO) olanlar",
      "Kronik yorgunluk ve açıklanamayan baş ağrılarından şikayetçi olanlar",
      "Histamin intoleransı belirtileri gösterenler",
      "Sedef hastalığı, kronik ürtiker veya akne ile mücadele edenler",
      "Romatizmal eklem hastalıkları olanlar",
      "Otoimmün hastalık tanısı almış veya şüphesi olanlar"
    ],
    "covers": [
      "Sindirim Sistemi: İnflamatuar Barsak Hastalığı, SİBO",
      "Kronik yorgunluk, Baş ağrısı",
      "Haşimoto Tiroiditi ve Zehirli Guatr",
      "Histamin İntoleransı",
      "Cilt Hastalıkları: Sedef Hastalığı, Kronik Ürtiker, Akne",
      "Romatizmal Eklem Hastalıkları",
      "Diğer Otoimmün hastalıklar"
    ],
    "faq": [
      {
        "q": "Fonksiyonel tıp klasik tıptan nasıl farklıdır?",
        "a": "Fonksiyonel tıp, semptomları maskelemek yerine hastalıkların kök nedenlerini araştırır. Vücudu bir bütün olarak değerlendirerek kişiye özel tedavi planları oluşturur."
      },
      {
        "q": "Hangi hastalıklarda fonksiyonel tıp yaklaşımı uygulanır?",
        "a": "Tiroid hastalıkları, sindirim sorunları, kronik yorgunluk, otoimmün hastalıklar, cilt problemleri, hormonal dengesizlikler ve daha birçok kronik rahatsızlıkta uygulanır."
      },
      {
        "q": "Tedavi süreci ne kadar sürer?",
        "a": "Tedavi süresi kişinin durumuna göre değişmekle birlikte, genellikle 3-6 aylık bir süreçte belirgin iyileşme gözlemlenir. Takip ve optimizasyon süreci devam edebilir."
      }
    ],
    "image": "https://static.prod-images.emergentagent.com/jobs/968a3b64-6092-48c3-9aea-fad3670f82b5/images/b74330d5205cd9b2cb0c28e8d1a1806c6242ad920ac07a9936a2d786ee925cdb.png"
  },
  {
    "id": "hormonal-antiaging",
    "title": "Hormonal Antiaging Program",
    "order": 2,
    "short": "Hormon dengesini optimize ederek enerji, zihinsel performans ve yaşam kalitesini artırmayı amaçlayan sağlıklı yaş alma programları",
    "icon": "Sparkles",
    "bullets": [
      "Menopozda Hormon Replasman Tedavisi",
      "Andropoz tedavisi",
      "Enerji ve Libido Eksikliğinde Hormon Destekleri",
      "Kronik stres ve Tükenmişlikte Hormon Destekleri",
      "Tiroid Hormonlarının Optimizasyonu"
    ],
    "overview": "Hormonal Antiaging Program, yaşlanma sürecinde hormon dengesizliklerinin yarattığı sorunlara bilimsel ve kişiye özel çözümler sunar. Hormonlar, vücudumuzdaki hemen her fonksiyonu düzenleyen kimyasal habercilerdir ve dengelerinin bozulması enerji kaybı, kilo artışı, uyku bozuklukları ve ruh hali değişimleri gibi birçok soruna yol açabilir.\n\nKapsamlı hormon paneli değerlendirmesi ile mevcut durumunuz analiz edildikten sonra, doğal yollarla ve gerektiğinde biyoidentik hormon replasman tedavisi ile dengeniz yeniden sağlanır.",
    "who_for": [
      "Menopoz veya perimenopoz belirtileri yaşayan kadınlar",
      "Andropoz dönemindeki erkekler",
      "Enerji ve libido kaybı yaşayanlar",
      "Kronik stres ve tükenmişlik sendromu olanlar",
      "Tiroid hormon dengesizliği olanlar",
      "Yaş almaya bağlı fiziksel ve zihinsel performans kaybı hissedenler"
    ],
    "covers": [
      "Menopozda Hormon Replasman Tedavisi",
      "Andropoz tedavisi",
      "Enerji ve Libido Eksikliğinde Hormon Destekleri",
      "Kronik stres ve Tükenmişlikte Hormon Destekleri",
      "Tiroid Hormonlarının Optimizasyonu"
    ],
    "faq": [
      {
        "q": "Hormon replasman tedavisi güvenli midir?",
        "a": "Biyoidentik hormonlar, vücudun doğal olarak ürettiği hormonlarla aynı yapıdadır. Doğru dozda ve uzman takibinde uygulandığında güvenli ve etkili bir tedavi yöntemidir."
      },
      {
        "q": "Hangi yaştan itibaren hormonal antiaging programa başlanabilir?",
        "a": "Hormon dengesizliği belirtileri kişiden kişiye farklı yaşlarda başlayabilir. Genellikle 35 yaş sonrası hormonal değişimler hızlanır, ancak belirtiler daha erken de görülebilir."
      },
      {
        "q": "Sonuçları ne zaman görmeye başlarım?",
        "a": "İlk iyileşme belirtileri genellikle 4-6 hafta içinde hissedilmeye başlar. Tam optimizasyon 3-6 ay sürebilir."
      }
    ],
    "image": "https://static.prod-images.emergentagent.com/jobs/968a3b64-6092-48c3-9aea-fad3670f82b5/images/8a717545ec0c864a5597b318f06180ebfa17786e56bbb886b84a330cfb1fbc21.png"
  },
  {
    "id": "stres-yonetimi",
    "title": "Otonom Sağlık ve Stres Yönetimi",
    "order": 3,
    "short": "Sağlıkta 3. Boyut HRV (Kalp Hızı Değişkenliği) temelli yöntemler ve nefes terapisi",
    "icon": "Brain",
    "bullets": [
      "Yaşam Enerjisi Analizi (Autonom Health®)",
      "Kalp Hızı Değişkenliği (HRV) Uygulamaları (HeartMath®)",
      "Vagus Uyarısı ile stres azaltma",
      "Bilinçli farkındalık-Mindfulness temelli stres azaltma",
      "Biyointegratif Nefes terapisi"
    ],
    "overview": "Stres yönetimi programımız, kronik stresin vücuttaki etkilerini bilimsel yöntemlerle ölçer ve kişiye özel stres azaltma teknikleri ile dengenizi yeniden kurmanıza yardımcı olur.\n\nKalp Hızı Değişkenliği (HRV) analizi ile stres düzeyinizi objektif olarak ölçüyor, HeartMath® sertifikalı uygulamalar, mindfulness, nefes terapisi ve NLP teknikleri ile hem fiziksel hem de duygusal stresinizi yönetmenizi sağlıyoruz.",
    "who_for": [
      "Kronik stres ve tükenmişlik sendromu yaşayanlar",
      "Anksiyete ve endişe problemi olanlar",
      "Uyku bozuklukları yaşayanlar",
      "İş ve yaşam dengesini kurmakta zorlananlar",
      "Odaklanma ve konsantrasyon güçlüğü çekenler",
      "Strese bağlı fiziksel belirtiler (baş ağrısı, kas gerginliği vb.) yaşayanlar"
    ],
    "covers": [
      "Yaşam Enerjisi Analizi (Autonom Health®)",
      "Kalp Hızı Değişkenliği (HRV) Uygulamaları (HeartMath®)",
      "Vagus Uyarısı ile stres azaltma",
      "Bilinçli farkındalık-Mindfulness temelli stres azaltma",
      "Biyointegratif Nefes terapisi"
    ],
    "faq": [
      {
        "q": "HRV analizi nedir?",
        "a": "Kalp Hızı Değişkenliği (HRV), kalp atışları arasındaki süre farklılıklarını ölçen bilimsel bir yöntemdir. Otonom sinir sisteminizin dengesini ve stres seviyenizi objektif olarak değerlendirir."
      },
      {
        "q": "HeartMath® nedir?",
        "a": "HeartMath®, kalp-beyin uyumunu artırmaya yönelik bilimsel olarak kanıtlanmış bir stres yönetimi sistemidir. Nefes ve odaklanma teknikleri ile stres tepkilerinizi yönetmeyi öğretir."
      },
      {
        "q": "Kaç seans gerekir?",
        "a": "Stres yönetimi programı genellikle 6-8 seanslık bir süreçtir. Ancak kişinin durumuna göre bu süre kısalabilir veya uzayabilir."
      }
    ],
    "image": "https://static.prod-images.emergentagent.com/jobs/968a3b64-6092-48c3-9aea-fad3670f82b5/images/42297724f6cd122d076f8820db4e1715eaef6d4fb3cb4d0e4ec6c116411ece53.png"
  },
  {
    "id": "koruyucu-hekimlik",
    "title": "Koruyucu Hekimlik",
    "order": 4,
    "short": "Hastalık oluşmadan önce sağlığı korumayı hedefleyen yaşam tarzı düzenlemeleri, detoks ve destek tedavileri",
    "icon": "ShieldCheck",
    "bullets": [
      "Yeme farkındalığı",
      "Hareketli yaşam ve sporcu desteği",
      "Detoks serumları ile koruyucu kürler"
    ],
    "overview": "Koruyucu hekimlik, hastalıkları oluşmadan önce önlemeyi ve vücudun doğal savunma mekanizmalarını güçlendirmeyi hedefleyen proaktif bir sağlık yaklaşımıdır.\n\nDetoks programları, sindirim sistemi restorasyonu, bilinçli beslenme ve hareketli yaşam planlaması ile vücudunuzun kendini yenileme kapasitesini en üst düzeye çıkarıyoruz. Damardan destek tedavileri ile hücresel düzeyde beslenme ve enerji optimizasyonu sağlıyoruz.",
    "who_for": [
      "Sindirim sorunları ve bağırsak geçirgenliği problemi yaşayanlar",
      "Sağlıklı beslenme alışkanlıkları edinmek isteyenler",
      "Aktif spor yapan ve performansını artırmak isteyenler",
      "Detoks ve arınma programı arayanlar",
      "Vitamin ve mineral eksiklikleri olanlar",
      "Genel sağlığını korumak ve güçlendirmek isteyenler"
    ],
    "covers": [
      "Yeme farkındalığı",
      "Hareketli yaşam ve sporcu desteği",
      "Detoks serumları ile koruyucu kürler"
    ],
    "faq": [
      {
        "q": "Damardan tedaviler nelerdir?",
        "a": "IV (intravenöz) tedaviler, vitamin, mineral ve antioksidanların doğrudan kan dolaşımına verilmesidir. Bu yöntem, sindirim sistemini atlayarak %100 emilim sağlar ve hızlı etki gösterir."
      },
      {
        "q": "Detoks programı ne kadar sürer?",
        "a": "Detoks programları kişinin ihtiyacına göre 2-4 hafta arasında planlanır. Süreç boyunca beslenme, takviye ve yaşam tarzı değişiklikleri birlikte uygulanır."
      }
    ],
    "image": "https://static.prod-images.emergentagent.com/jobs/968a3b64-6092-48c3-9aea-fad3670f82b5/images/391e75dfa8c488c4062a3d780ca670e3ed5c1e5c076b369b9fc25158f320f0a9.png"
  },
  {
    "id": "yenileyici-uygulamalar",
    "title": "Yenileyici Uygulamalar",
    "order": 5,
    "short": "Ağrı ve bölgesel problemlerde hedef dokuya yönelik çözümler",
    "icon": "Sparkles",
    "image": "https://static.prod-images.emergentagent.com/jobs/bcffc888-f44b-48a9-bd37-b6635c646bda/images/94c28cd9173c8e43c2973c41c631f5a27fc5bd3f24d01822ac9b67e94ad2615c.png",
    "bullets": [
      "Mezoterapi",
      "PRP Uygulamaları"
    ],
    "overview": "Yenileyici uygulamalar, ağrı ve bölgesel problemlerde hedef dokuya yönelik etkili çözümler sunar. Mezoterapi ve PRP uygulamaları ile dokunun yenilenmesini ve iyileşmesini destekleriz.",
    "covers": [
      "Mezoterapi",
      "PRP Uygulamaları"
    ],
    "who_for": [],
    "faq": [
      {
        "q": "Mezoterapi nedir?",
        "a": "Mezoterapi, vitamin, mineral ve aktif bileşenlerin mikro enjeksiyonlarla deri altına uygulanmasıdır."
      },
      {
        "q": "PRP uygulaması nasıl yapılır?",
        "a": "PRP, kişinin kendi kanından elde edilen trombositten zengin plazmanın hedef bölgeye enjekte edilmesidir."
      },
      {
        "q": "Kaç seans gerekir?",
        "a": "Genellikle 4-6 seans önerilir, seanslar 2-4 hafta aralıklarla yapılır."
      }
    ]
  }
];

export const DEFAULT_FAQ = [
  {
    "order": 1,
    "a": "Bir enfeksiyon kapsanız, ateşiniz çıksa veya ufak bir kaza geçirseniz başvurduğunuz doktor zaman kaybetmeden tanıyı koyup gerekli tedaviyi başlar. Büyük ihtimalle de kısa sürede iyileşip eski halinize dönersiniz.\n\nAncak bazen özellikle kronik hastalıklarda durum çok farklı. Sessizce ilerleyip bir tetikleyici faktörle alevlenen kronik hastalıklarda rahatsızlıklar bir branş hekiminin alanında sınırlı kalmıyor ve genellikle tüm sistemleri etkiliyor. Birçok hekim gezmiş, her türlü tetkiki yaptırmış ve bir avuç dolusu ilaç reçete edilmiş bu hastaların çaresizliğini ancak yaşayan anlar. Fonksiyonel tıp bakış açısı işte bu hastalar için çok önemli ve gerekli.",
    "q": "Fonksiyonel Tıp Danışmanlığı Kimler İçin Uygundur?",
    "id": "3ea2dc8a"
  },
  {
    "order": 2,
    "a": "Branşı ne olursa olsun tüm sistemleri, tüm tetkikleri gözden geçirerek vücutta birbirini etkileyecek mekanizmaları incelen ve kök nedenleri araştırarak çözüme gitmeye çalışan bir doktoru bulmak elbette çok zor. Rutin sağlık hizmetlerinde böyle bir uygulama yapmak ise imkânsız.\n\nBu nedenle fonksiyonel tıp danışmanlığı için uzun ve detaylı bir gözden geçirme eğitimi, analitik bir bakış açısı, pratik yaparken destek alabilecek iyi bir ekip ve tabii çok emek gerekiyor.",
    "q": "Fonksiyonel Tıp Hekimi Kimdir?",
    "id": "10777b7a"
  },
  {
    "order": 3,
    "a": "Klasik tıpta branşlaşma bir bilim dalında derinlemesine uzmanlaşmayı sağladığı için hem bilimsel gelişmeler hem de iş bölümü açısından çok gerekli ve bir o kadar da pratik bir uygulama. Ancak modern şehir yaşamı, beslenme bozuklukları, hareketsizlik, stres ve toksinler tüm sistemleri etkilediği için bütüncül değerlendirmenin eksikliği günümüzde daha da önemli hale geldi. Klasik tıp branşlarının bilgi ve tecrübesinden yararlanıp hastayı tümüyle değerlendirmek ise en işlevsel (fonksiyonel) çözüm gibi görünüyor.\n\nFonksiyonel tıpta tanı kadar tedavi süreci de klasik tıp yaklaşımından farklılıklar gösterir. Öncelikle hastanın biyolojik, sosyal ve psikolojik şartlarına uygun olarak yani kişiye özel olarak planlanır. Tabi bu aşamada hastanın da samimi iş birliği gereklidir. Yol göstermek, çözüm bulmak kadar o yolda yürümek ve yılmamak da önemli. Yani sizi iyileştirecek olan yine sizin isteğiniz ve uyumunuz olacak.",
    "q": "Fonksiyonel Tıp Uygulamalarının Klasik Tıp Anlayışından Farkı Nedir?",
    "id": "3c24dce7"
  },
  {
    "order": 4,
    "a": "Eğer fonksiyonel tıp danışmanlığına ihtiyacınız olduğunu düşünüyorsanız randevu almadan önce hizmetlerimiz ile ilgili detayları inceleyebilirsiniz. İletişim bölümünde bulunan tanışma formunu doldurarak Sade Düşün iletişim numarasına (+90 546 573 99 33) WhatsApp mesajı olarak veya sadedusun@gmail.com adresine e-posta yoluyla göndermenizi rica ediyoruz.\n\nTanışma Formunda; isim, telefon, e-posta adresi, cinsiyet, yaş, yaşadığınız şehir, şikâyetiniz ve tanı almış bir hastalığınız varsa kısaca bilgi veren bu formu bize gönderirseniz 1-3 iş günü içinde randevunuz için sizi ararız.",
    "q": "Nasıl Randevu Alırım?",
    "id": "1ce3617e"
  },
  {
    "order": 5,
    "a": "Bütünsel iyileşme yoluna çıkmadan önce size yardımcı olabileceğimiz ve olamayacağımız konuları konuşmak ve tedaviden beklentilerimizi karşılıklı olarak belirlemek çok önemli. Bu nedenle ilk randevu öncelikle tanışma amaçlıdır.\n\nSonrasında daha detaylı bir tıbbi sorgulama formu, stres anketi ve alışkanlıklarınız ile ilgili soruları e-posta yoluyla size göndereceğiz. Yüz yüze görüşmeler sırasında formları doldurarak vakit kaybetmek yerine şikayetleriniz hakkında karşılıklı konuşmak daha verimli olacaktır. İşte bu yüzden formları detaylı olarak doldurmanızı rica ediyoruz.\n\nHakkınızdaki bütüncül değerlendirme yapılıp gerekli tetkikler ikinci seans öncesi belirlenirse iyileşmek için bir an önce başlayabiliriz. Tetkiklerinizi yaptırıp bize e-posta (sadedusun@gmail.com) ile ulaştırabilirsiniz. Böylece ikinci seans için görüşmeye geldiğinizde gerekli öneriler ve yol haritası sizinle paylaşılır, iş birliği açısından ortak görüşler belirlenir. Bu süreçte kişiye ve hastalığa özgü değişkenler dikkate alınarak güncellemeler yapılabilir.",
    "q": "Danışmanlık Süreci Nasıl İlerliyor?",
    "id": "612cfacb"
  },
  {
    "order": 6,
    "a": "Rahatsızlık duyduğunuz, şikâyet ettiğiniz bu durum ne zamandır hayatınızda bir düşünün? Uzun süredir bizimle olan aksaklıkları düzeltmek, en azından ilerlemesini durdurmak da zaman alır. Genellikle 3-6 ay gibi bir sürede düze çıkmayı hedefleriz. Hastalarımızın bu konuda sabırlı olması, kendine ve bize inanması da tedavi sürecini kolaylaştıracaktır.",
    "q": "Fonksiyonel Tıp Tedavileri Ne Kadar Sürer?",
    "id": "9d75b35b"
  },
  {
    "order": 7,
    "a": "Fonksiyonel tıp uygulamalarının kısıtlı olmasının iki önemli nedeni yetkin doktor eksikliği ve masraflı olmasıdır. Danışmanlık hizmeti, gıda takviyeleri veya stres yönetimi seansları maalesef sağlık güvencesi kapsamında değildir. Laboratuvar tetkiklerinin birçoğunu hastanede yaptırabilirsiniz ancak bazıları sadece özel laboratuvarlarda yapılmaktadır.\n\nTam bir iyilik haline kavuşmak için yapılan tüm uygulamaların sağlık sigortaları tarafından karşılanması gerektiğine biz de katılıyoruz, ancak henüz böyle bir imkân olmadığından tedavi süreci için bir bütçe ayırmanız gerekecek. Kendiniz ve sağlığınız için bir yatırım olarak düşünürseniz günlük hayatta yaptığınız gereksiz birkaç harcamadan fedakârlık edebilirsiniz.\n\nDanışmanlık ücreti tedavi sürecine ve kapsamına göre değişkenlik gösterdiğinden bu konuda Sade Düşün iletişim hattından (+90 546 573 99 33) bilgi alabilirsiniz.",
    "q": "Bu Uygulamalar Sağlık Sigortası Kapsamında mıdır?",
    "id": "cfcfec69"
  },
  {
    "order": 8,
    "a": "Sağlık hizmetinde tedavi kadar ve hatta daha önemli bir diğer alan hastalıklardan korunmadır. Hastalıklarla baş etmenin en kolay ve ucuz yolu, hastalığa yakalanmadan önce gerekli önlemlerin alınmasıdır.\n\nBireyin biyolojik, sosyal ve psikolojik özellikleri dikkate alınarak uygulanan kişiselleştirilmiş koruyucu hekimlik hizmetleri sadece hastalıklardan korunmayı değil sağlıklı ve konforlu bir yaşamı amaçlar. Kişiye özel koruyucu hekimlikte danışan detaylı olarak araştırılıp fonksiyonel check-up yapılır. Böylece biyolojik, sosyal, ailesel riskleri belirlenir ve gerekli önlemler doğrultusunda hasta ile iş birliği yapılır.\n\nKoruyucu hekimlik uygulamalarında sadece ilaçlar kullanılmaz, hatta genellikle ilaçlar hiç kullanılmaz. Sağlıklı ve dengeli beslenme, fiziksel hareketliliğin günlük hayata uyarlanması, stres yönetimi, kaliteli uyku alışkanlığı, detoks sistemlerinin desteklenmesi, vitamin ve diğer gıda takviyeleri gibi konularda önerilerde bulunulur.",
    "q": "Koruyucu Hekimlik Nedir?",
    "id": "aa3273ba"
  },
  {
    "order": 9,
    "a": "Sizinle yüz yüze tanışıp, tedavi süreciniz hakkında konuşmayı ve fikrinizi alarak iş birliği yapmayı tercih ederiz. Özellikle bütüncül iyilik halinin en önemli parçalarından olan stres yönetimi ve nefes terapisi için yüz yüze görüşmeler çok daha etkilidir.\n\nAncak yoğun iş temposu ve farklı şehir gibi sebeplerle her zaman bunu gerçekleştirmek mümkün olmuyor. Yüz yüze görüşmeye gelemeyen hastalarımızla internetten görüntülü konuşma seanslarıyla da çok güzel yol alabiliyoruz.",
    "q": "Online Danışmanlık Alabilir miyim?",
    "id": "b2efd3a1"
  }
];

export const DEFAULT_SYMPTOMS = [
  {
    "id": "1",
    "label": "Kronik Yorgunluk",
    "description": "Gün boyu süren, dinlenmekle geçmeyen yorgunluk ve enerji düşüklüğü.",
    "icon": "Battery",
    "weights": {
      "fonksiyonel-tip": 35,
      "hormonal-antiaging": 30,
      "koruyucu-hekimlik": 20,
      "stres-yonetimi": 15,
      "yenileyici-uygulamalar": 5
    }
  },
  {
    "id": "2",
    "label": "Sindirim Sorunları",
    "description": "Şişkinlik, gaz, kabızlık, ishal veya mide yanması gibi sindirim şikayetleri.",
    "icon": "Leaf",
    "weights": {
      "fonksiyonel-tip": 50,
      "hormonal-antiaging": 10,
      "koruyucu-hekimlik": 30,
      "stres-yonetimi": 10,
      "yenileyici-uygulamalar": 5
    }
  },
  {
    "id": "3",
    "label": "Uyku Bozuklukları",
    "description": "Uykuya dalma güçlüğü, sık uyanma veya dinlendirici olmayan uyku.",
    "icon": "Moon",
    "weights": {
      "fonksiyonel-tip": 15,
      "hormonal-antiaging": 25,
      "koruyucu-hekimlik": 10,
      "stres-yonetimi": 50,
      "yenileyici-uygulamalar": 5
    }
  },
  {
    "id": "4",
    "label": "Kilo Yönetimi Güçlüğü",
    "description": "Açıklanamayan kilo alma, kilo verememe veya inatçı bölgesel yağlanma.",
    "icon": "Scale",
    "weights": {
      "fonksiyonel-tip": 25,
      "hormonal-antiaging": 40,
      "koruyucu-hekimlik": 25,
      "stres-yonetimi": 10,
      "yenileyici-uygulamalar": 10
    }
  },
  {
    "id": "5",
    "label": "Stres ve Anksiyete",
    "description": "Sürekli gerginlik, endişe, panik atak veya odaklanma güçlüğü.",
    "icon": "Brain",
    "weights": {
      "fonksiyonel-tip": 10,
      "hormonal-antiaging": 10,
      "koruyucu-hekimlik": 10,
      "stres-yonetimi": 70,
      "yenileyici-uygulamalar": 5
    }
  },
  {
    "id": "6",
    "label": "Cilt Problemleri",
    "description": "Akne, egzama, sedef, kronik ürtiker veya açıklanamayan cilt döküntüleri.",
    "icon": "Sparkles",
    "weights": {
      "fonksiyonel-tip": 70,
      "hormonal-antiaging": 10,
      "koruyucu-hekimlik": 15,
      "stres-yonetimi": 5,
      "yenileyici-uygulamalar": 35
    }
  },
  {
    "id": "7",
    "label": "Hormonal Dengesizlik",
    "description": "Düzensiz adet, sıcak basması, ruh hali dalgalanmaları veya libido kaybı.",
    "icon": "Heart",
    "weights": {
      "fonksiyonel-tip": 20,
      "hormonal-antiaging": 55,
      "koruyucu-hekimlik": 10,
      "stres-yonetimi": 15,
      "yenileyici-uygulamalar": 5
    },
    "skippable": true,
    "skipNote": "Bu soru size uygun değilse geçebilirsiniz"
  },
  {
    "id": "8",
    "label": "Bağışıklık Zayıflığı",
    "description": "Sık hastalanma, iyileşme sürecinin uzaması veya sürekli enfeksiyon.",
    "icon": "Shield",
    "weights": {
      "fonksiyonel-tip": 30,
      "hormonal-antiaging": 10,
      "koruyucu-hekimlik": 40,
      "stres-yonetimi": 20,
      "yenileyici-uygulamalar": 5
    }
  }
];

export const DEFAULT_PROCESS_STEPS = [
  {
    "id": "1",
    "step": 1,
    "title": "Analiz ve Yol Haritası",
    "description": "Kapsamlı sağlık geçmişi, yaşam tarzı ve şikayetleriniz değerlendirilir; ileri düzey laboratuvar testleri ile kök nedenler belirlenir ve kişiye özel tedavi yol haritası oluşturulur.",
    "icon": "ClipboardList"
  },
  {
    "id": "2",
    "step": 2,
    "title": "Uygulama ve Takip",
    "description": "Beslenme düzeni, takviyeler ve gerekli tedaviler uygulamaya alınır; süreç düzenli görüşmelerle yakından takip edilir.",
    "icon": "FileText"
  },
  {
    "id": "3",
    "step": 3,
    "title": "Tedavi Değerlendirme",
    "description": "Uygulanan tedavinin etkinliği değerlendirilir, test sonuçları ve iyileşme süreci analiz edilir, gerekli protokol güncellemeleri yapılır.",
    "icon": "MessageCircle"
  },
  {
    "id": "4",
    "step": 4,
    "title": "Koruma ve Optimizasyon",
    "description": "Elde edilen sonuçların korunması için düzenli kontrol görüşmeleri planlanır, plan optimize edilir ve uzun vadeli sağlık hedefleri desteklenir.",
    "icon": "TrendingUp"
  }
];

export const DEFAULT_PROCESS_TIMELINE = [
  {
    "id": "1",
    "day": "Gün 1-3",
    "title": "Ön Görüşme ve Planlama",
    "desc": "Kapsamlı sağlık geçmişiniz değerlendirilir, test ve analiz planınız oluşturulur."
  },
  {
    "id": "2",
    "day": "Gün 3-7",
    "title": "Testler ve Analizler",
    "desc": "Laboratuvar testleri, hormon paneli ve gerekli tüm analizler tamamlanır."
  },
  {
    "id": "3",
    "day": "Gün 7-10",
    "title": "Sonuç Değerlendirme",
    "desc": "Test sonuçları detaylı şekilde yorumlanır, bulgular sizinle paylaşılır."
  },
  {
    "id": "4",
    "day": "Gün 10-14",
    "title": "Kişisel Plan Sunumu",
    "desc": "Size özel beslenme, yaşam tarzı, takviye ve tedavi planınız hazırlanır ve sunulur."
  },
  {
    "id": "5",
    "day": "Gün 14-28",
    "title": "Uygulama ve Adaptasyon",
    "desc": "Planınızı uygulamaya başlarsınız, sorularınız yanıtlanır ve gerekli ayarlamalar yapılır."
  },
  {
    "id": "6",
    "day": "Gün 28-30",
    "title": "İlk Kontrol",
    "desc": "İlk takip görüşmeniz yapılır, ilerlemeniz değerlendirilir ve plan güncellenir."
  }
];

export const DEFAULT_CERTIFICATES = [
  {
    "order": 2,
    "title": "Tıp Doktoru Diploması",
    "institution": "Hacettepe Üniversitesi Tıp Fakültesi",
    "year": "1999",
    "type": "Diploma",
    "id": "0fe21ad9"
  },
  {
    "order": 3,
    "title": "Nükleer Tıp Uzmanlık Diploması",
    "institution": "Gazi Üniversitesi Tıp Fakültesi – Nükleer Tıp ABD",
    "year": "2004",
    "type": "Diploma",
    "id": "902367da"
  },
  {
    "order": 4,
    "title": "Nükleer Tıp Doçentlik Unvanı",
    "institution": "Üniversitelerarası Kurul (Türkiye)",
    "year": "2015",
    "type": "Akademik",
    "id": "fc9997ca"
  },
  {
    "order": 5,
    "title": "Sağlık Kuruluşları İşletmesi Yüksek Lisans Diploması",
    "institution": "(Üniversite belirtilmemiş)",
    "year": "2018",
    "type": "Diploma",
    "id": "7fe42eca"
  },
  {
    "order": 6,
    "title": "Fonksiyonel Tıp Akademisi Eğitimi",
    "institution": "Fonksiyonel Tıp Akademisi",
    "year": "2020",
    "type": "Sertifika",
    "id": "068cc441"
  },
  {
    "order": 7,
    "title": "HRV-Professional Sertifikası",
    "institution": "Autonom Health",
    "year": "2026",
    "type": "Sertifika",
    "id": "fd244c74"
  },
  {
    "order": 8,
    "title": "HeartMath® Certified Practitioner",
    "institution": "HeartMath Institute",
    "year": "2026",
    "type": "Sertifika",
    "id": "9483a4b4"
  },
  {
    "order": 9,
    "title": "Nükleer Tıp Profesörlük Unvanı",
    "institution": "Ankara Yıldırım Beyazıt Üniversitesi",
    "year": "2021",
    "type": "Akademik",
    "id": "5e0f36e2"
  },
  {
    "order": 10,
    "title": "Ankara Yıldırım Beyazıt Üniversitesi Tıp Fakültesi Öğretim Üyeliği",
    "institution": "Ankara Yıldırım Beyazıt Üniversitesi",
    "year": "2026",
    "type": "Akademik",
    "id": "937f36bc"
  },
  {
    "order": 11,
    "title": "Ulusal ve Uluslararası Hakemli Dergilerde Yayınlar (Bilimsel Makale ve Kitap Bölümü)",
    "institution": "Çeşitli Akademik Yayın Kuruluşları",
    "year": "2026",
    "type": "Akademik",
    "id": "f8764445"
  }
];

export const DEFAULT_BLOGS = [
  {
    "title": "Haşimoto Tiroiditi: Belirtiler, Kök Nedenler ve Fonksiyonel Tıp Yaklaşımı",
    "slug": "hasimoto-tiroiditi-fonksiyonel-tip",
    "category": "Fonksiyonel Tıp",
    "related_service": "fonksiyonel-tip",
    "date": "2026-02-20",
    "order": 10,
    "excerpt": "Haşimoto tiroiditi, bağışıklık sisteminin tiroid bezine saldırdığı otoimmün bir hastalıktır. Fonksiyonel tıp yaklaşımıyla kök nedenlere inerek kalıcı çözümler mümkündür.",
    "content": "<p>Haşimoto tiroiditi, dünyada en sık görülen otoimmün hastalıklardan biridir ve özellikle kadınlarda yaygındır. Klasik tıpta genellikle tiroid hormonu takviyesi ile yönetilirken, fonksiyonel tıp yaklaşımı hastalığın <strong>kök nedenlerini</strong> araştırır.</p><p>Haşimoto'nun altında yatan başlıca faktörler:</p><ul><li><strong>Bağırsak geçirgenliği (Leaky Gut):</strong> Bağırsak bariyerinin bozulması, bağışıklık sisteminin aşırı aktifleşmesine yol açar</li><li><strong>Gluten hassasiyeti:</strong> Gluten proteini, tiroid dokusuyla moleküler benzerlik gösterdiğinden otoimmün yanıtı tetikleyebilir</li><li><strong>Besin eksiklikleri:</strong> Selenyum, çinko, D vitamini ve demir eksiklikleri tiroid fonksiyonunu doğrudan etkiler</li><li><strong>Toksin yükü:</strong> Ağır metaller ve çevresel toksinler tiroid bezinin çalışmasını bozar</li></ul><p>Fonksiyonel tıp yaklaşımında önce kapsamlı laboratuvar testleriyle mevcut durum değerlendirilir. Ardından kişiye özel bir beslenme planı, bağırsak restorasyonu protokolü ve gerekli takviyeler ile tedavi süreci başlatılır.</p><p>Haşimoto tedavisinde sabır önemlidir. Genellikle 3-6 aylık bir süreçte belirgin iyileşme gözlemlenir.</p>",
    "id": "2e962f7e",
    "image": "https://images.unsplash.com/photo-1650472614562-743b8e1fbe6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHx0aHlyb2lkJTIwaGVhbHRoJTIwbWVkaWNhbHxlbnwwfHx8fDE3NzIxNDM2NzJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "SİBO Nedir? Şişkinlik ve Sindirim Sorunlarının Gizli Nedeni",
    "slug": "sibo-siskinlik-sindirim-sorunlari",
    "category": "Fonksiyonel Tıp",
    "related_service": "fonksiyonel-tip",
    "date": "2026-02-18",
    "order": 9,
    "excerpt": "Sürekli şişkinlik, gaz ve karın ağrısıyla mı mücadele ediyorsunuz? Belki de sorunun adı SİBO — İnce Bağırsak Bakteriyel Aşırı Çoğalmasıdır.",
    "content": "<p><strong>SİBO (Small Intestinal Bacterial Overgrowth)</strong>, ince bağırsakta normalde düşük miktarda bulunan bakterilerin aşırı çoğalmasıdır. Bu durum sindirim sürecini ciddi şekilde bozar.</p><p>SİBO'nun en yaygın belirtileri:</p><ul><li>Yemeklerden sonra şiddetli şişkinlik</li><li>Aşırı gaz ve karın ağrısı</li><li>İshal veya kabızlık</li><li>Besin emilim bozukluğu ve vitamin eksiklikleri</li><li>Kronik yorgunluk</li></ul><p>Fonksiyonel tıp yaklaşımında tedavi üç aşamadan oluşur:</p><ol><li><strong>Eliminasyon:</strong> Bakteriyel aşırı çoğalmayı kontrol altına alma</li><li><strong>Restorasyon:</strong> Bağırsak bariyerinin onarılması ve mikrobiyom dengesinin yeniden kurulması</li><li><strong>Önleme:</strong> Tekrarlamayı engelleyecek beslenme ve yaşam tarzı değişiklikleri</li></ol><p>Doğru yaklaşımla çoğu hasta birkaç hafta içinde belirgin rahatlama hisseder.</p>",
    "id": "1878b708",
    "image": "https://images.unsplash.com/photo-1649073586104-2ac3fab175ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkaWdlc3RpdmUlMjBoZWFsdGglMjBndXR8ZW58MHx8fHwxNzcyMTQzNjczfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "Menopozda Hormon Replasman Tedavisi: Bilmeniz Gereken Her Şey",
    "slug": "menopozda-hormon-replasman-tedavisi",
    "category": "Hormonal Antiaging",
    "related_service": "hormonal-antiaging",
    "date": "2026-02-16",
    "order": 8,
    "excerpt": "Menopoz döneminde yaşanan sıcak basması, uyku bozuklukları ve ruh hali değişimlerine karşı biyoidentik hormon tedavisi güvenli ve etkili bir çözüm sunuyor.",
    "content": "<p>Menopoz, kadın yaşamının doğal bir evresidir ancak beraberinde getirdiği semptomlar yaşam kalitesini ciddi şekilde düşürebilir. <strong>Sıcak basması, gece terlemesi, uyku bozuklukları, vajinal kuruluk, ruh hali dalgalanmaları</strong> ve <strong>kemik yoğunluğu kaybı</strong> en yaygın şikayetler arasındadır.</p><p><strong>BHRT'nin faydaları:</strong></p><ul><li>Sıcak basması ve gece terlemesinde %85'e varan azalma</li><li>Uyku kalitesinde belirgin iyileşme</li><li>Kemik yoğunluğunun korunması</li><li>Cilt elastikiyetinin artması</li><li>Bilişsel fonksiyonların desteklenmesi</li></ul><p>Tedaviye başlamadan önce kapsamlı bir hormon paneli değerlendirmesi yapılır. Kişinin ihtiyaçlarına göre östrojen, progesteron ve gerektiğinde testosteron dozları ayarlanır.</p>",
    "id": "dbf2f8d6",
    "image": "https://images.unsplash.com/photo-1713865472921-25487ad6028f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtZW5vcGF1c2UlMjB3b21lbiUyMGhlYWx0aCUyMGhvcm1vbmV8ZW58MHx8fHwxNzcyMTQzNjc0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "Erkeklerde Testosteron Düşüklüğü: Belirtiler ve Doğal Çözümler",
    "slug": "erkeklerde-testosteron-dusuklugu",
    "category": "Hormonal Antiaging",
    "related_service": "hormonal-antiaging",
    "date": "2026-02-14",
    "order": 7,
    "excerpt": "Enerji kaybı, kas erimesi, libido düşüklüğü ve motivasyon eksikliği yaşıyorsanız testosteron seviyenizi kontrol ettirmenin zamanı gelmiş olabilir.",
    "content": "<p>Testosteron, erkek sağlığının temel taşıdır. 30'lu yaşlardan itibaren her yıl yaklaşık %1 oranında doğal bir düşüş gösterir.</p><p><strong>Düşük testosteronun belirtileri:</strong></p><ul><li>Kronik yorgunluk ve enerji düşüklüğü</li><li>Kas kütlesi kaybı ve güç azalması</li><li>Karın bölgesinde yağlanma artışı</li><li>Libido ve cinsel performans düşüklüğü</li><li>Konsantrasyon güçlüğü ve hafıza zayıflığı</li></ul><p><strong>Testosteronu doğal yollarla desteklemenin yolları:</strong></p><ol><li><strong>Direnç egzersizi:</strong> Ağırlık antrenmanı testosteron üretimini doğrudan artırır</li><li><strong>Uyku optimizasyonu:</strong> Testosteronun büyük bölümü derin uyku sırasında üretilir</li><li><strong>Stres yönetimi:</strong> Kronik stres kortizol yükseltir, kortizol testosteronu baskılar</li><li><strong>Beslenme:</strong> Çinko, magnezyum, D vitamini ve sağlıklı yağlar testosteron üretimini destekler</li></ol>",
    "id": "b30cefe3",
    "image": "https://images.unsplash.com/photo-1692055519446-f56410ba6835?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtYW4lMjBmaXRuZXNzJTIwdGVzdG9zdGVyb25lJTIwaGVhbHRofGVufDB8fHx8MTc3MjE0MzY3NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "Bağırsak Bariyeri Nedir ve Neden Bu Kadar Önemli?",
    "slug": "bagirsak-bariyeri-nedir",
    "category": "Koruyucu Hekimlik",
    "related_service": "koruyucu-hekimlik",
    "date": "2026-02-12",
    "order": 6,
    "excerpt": "Bağırsak bariyeriniz sağlığınızın ilk savunma hattıdır. Geçirgen bağırsak sendromu, alerjilerden otoimmün hastalıklara kadar birçok kronik sorunun tetikçisi olabilir.",
    "content": "<p>Bağırsak bariyeri, sindirim sisteminizi dış dünyadan ayıran ve sadece tek bir hücre kalınlığında olan kritik bir koruma katmanıdır.</p><p><strong>Bağırsak bariyerini bozan faktörler:</strong></p><ul><li>İşlenmiş gıdalar ve rafine şeker</li><li>Gluten ve lektinler (hassas kişilerde)</li><li>Kronik stres ve uyku yetersizliği</li><li>Antibiyotik ve NSAID grubu ilaçların aşırı kullanımı</li></ul><p><strong>Bağırsak bariyerini onarmak için 4R protokolü:</strong></p><ol><li><strong>Remove:</strong> Zararlı gıdaları ve patojenleri elimine et</li><li><strong>Replace:</strong> Sindirim enzimleri ve mide asidini destekle</li><li><strong>Reinoculate:</strong> Probiyotik ve prebiyotiklerle mikrobiyomu yeniden kur</li><li><strong>Repair:</strong> L-glutamin, çinko ve kollajen ile bariyer bütünlüğünü sağla</li></ol>",
    "id": "e0af60d7",
    "image": "https://images.unsplash.com/photo-1546553836-33b20490e87e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxndXQlMjBoZWFsdGglMjBudXRyaXRpb24lMjBmb29kfGVufDB8fHx8MTc3MjE0MzY3Nnww&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "IV Vitamin Tedavisi: Damardan Destek ile Hücresel Yenilenme",
    "slug": "iv-vitamin-tedavisi-damardan-destek",
    "category": "Koruyucu Hekimlik",
    "related_service": "koruyucu-hekimlik",
    "date": "2026-02-10",
    "order": 5,
    "excerpt": "IV vitamin tedavisi, besin maddelerinin doğrudan kan dolaşımına verilerek %100 emilim sağlayan güçlü bir destekleyici tedavi yöntemidir.",
    "content": "<p>Ağızdan alınan vitamin ve minerallerin emilim oranı %10-60 arasında değişir. <strong>IV vitamin tedavisi</strong> ise <strong>%100 emilim</strong> sağlar.</p><p><strong>En yaygın IV kokteylleri:</strong></p><ul><li><strong>Myers Kokteyli:</strong> Magnezyum, kalsiyum, B vitaminleri ve C vitamini</li><li><strong>Yüksek Doz C Vitamini:</strong> Bağışıklık güçlendirme ve antioksidan desteği</li><li><strong>Glutatyon:</strong> Karaciğer detoksu ve cilt aydınlatma</li><li><strong>NAD+:</strong> Hücresel enerji üretimi ve anti-aging</li></ul><p>IV tedaviler klinik ortamında, uzman hekim gözetiminde uygulanır.</p>",
    "id": "f2cd8ea6",
    "image": "https://images.unsplash.com/photo-1648139347040-857f024f8da4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxJViUyMHZpdGFtaW4lMjBkcmlwJTIwdGhlcmFweXxlbnwwfHx8fDE3NzIxNDM2NzZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "HRV Nedir? Kalp Hızı Değişkenliği ile Stres Seviyenizi Ölçün",
    "slug": "hrv-kalp-hizi-degiskenligi-stres",
    "category": "Stres Yönetimi",
    "related_service": "stres-yonetimi",
    "date": "2026-02-08",
    "order": 4,
    "excerpt": "HRV, stres düzeyinizi ve genel sağlık durumunuzu objektif olarak ölçen bilimsel bir yöntemdir.",
    "content": "<p><strong>Kalp Hızı Değişkenliği (HRV)</strong>, ardışık kalp atışları arasındaki süre farklılıklarının ölçümüdür.</p><p><strong>Yüksek HRV</strong> otonom sinir sisteminizin dengede olduğunu gösterir. <strong>Düşük HRV</strong> ise kronik stresin habercisi olabilir.</p><p><strong>HRV'yi etkileyen faktörler:</strong></p><ul><li><strong>Uyku kalitesi:</strong> Kötü uyku HRV'yi düşürür</li><li><strong>Stres düzeyi:</strong> Kronik stres HRV'yi baskılar</li><li><strong>Egzersiz:</strong> Düzenli egzersiz HRV'yi artırır</li><li><strong>Beslenme:</strong> İnflamasyon yaratan gıdalar HRV'yi olumsuz etkiler</li></ul><p>Kliniğimizde profesyonel HRV ölçümü yapılarak stres profiliniz çıkarılır. HeartMath teknikleri, nefes terapisi ve yaşam tarzı düzenlemeleriyle HRV değerleriniz optimize edilir.</p>",
    "id": "31436a5a",
    "image": "https://images.unsplash.com/photo-1655970580622-4a547789c850?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxoZWFydCUyMHJhdGUlMjBzdHJlc3MlMjBtZWRpdGF0aW9uJTIwYnJlYXRoaW5nfGVufDB8fHx8MTc3MjE0MzY4NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "Nefes Terapisi: Stres ve Anksiyeteye Karşı En Güçlü Doğal Silah",
    "slug": "nefes-terapisi-stres-anksiyete",
    "category": "Stres Yönetimi",
    "related_service": "stres-yonetimi",
    "date": "2026-02-06",
    "order": 3,
    "excerpt": "Doğru nefes teknikleri, dakikalar içinde sinir sisteminizi sakinleştirebilir.",
    "content": "<p>Nefes, otonom sinir sistemimizi bilinçli olarak etkileyebildiğimiz en güçlü araçtır.</p><p><strong>Bilimsel olarak kanıtlanmış nefes teknikleri:</strong></p><ul><li><strong>4-7-8 Tekniği:</strong> 4 saniye nefes al, 7 saniye tut, 8 saniye yavaşça ver</li><li><strong>Kutu Nefes:</strong> 4-4-4-4 ritmiyle nefes al, tut, ver, tut</li><li><strong>Diyafram Nefesi:</strong> Karından derin nefes alarak diyaframı aktive etme</li><li><strong>Alternatif Burun Nefesi:</strong> Sağ ve sol burun deliğinden dönüşümlü nefes</li></ul><p><strong>Faydaları:</strong></p><ol><li>Kortizol seviyesini düşürür</li><li>Kan basıncını normalize eder</li><li>HRV'yi artırır</li><li>Uyku kalitesini iyileştirir</li><li>Odaklanma ve berraklığı artırır</li></ol>",
    "id": "af9fd616",
    "image": "https://images.unsplash.com/photo-1713428856080-43fc975d2496?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxicmVhdGhpbmclMjBleGVyY2lzZSUyMHlvZ2ElMjBjYWxtfGVufDB8fHx8MTc3MjE0MzY4Nnww&ixlib=rb-4.1.0&q=85"
  },
  {
    "title": "Mezoterapi ile Cilt Yenileme: Işıltılı ve Genç Bir Cilde Kavuşun",
    "slug": "mezoterapi-cilt-yenileme",
    "category": "Mezoterapi",
    "related_service": "mezoterapi",
    "date": "2026-02-04",
    "order": 2,
    "excerpt": "Mezoterapi, vitamin ve aktif bileşenlerin deri altına mikro enjeksiyonlarla uygulanarak cildin yenilenmesini sağlayan etkili bir tedavidir.",
    "content": "<p>Mezoterapi, <strong>vitamin, mineral, amino asit, hyalüronik asit ve antioksidanlar</strong> gibi aktif bileşenlerin çok ince iğnelerle derinin orta tabakasına enjekte edilmesidir.</p><p><strong>Yüz mezoterapisinin faydaları:</strong></p><ul><li>Cilt neminin ve elastikiyetinin artması</li><li>İnce çizgi ve kırışıklıkların azalması</li><li>Cilt tonunun eşitlenmesi ve leke açılması</li><li>Kolajen üretiminin stimülasyonu</li><li>Gözeneklerin sıkılaşması</li></ul><p>İlk seansta cilt analizi yapılarak kişiye özel mezoterapi kokteyli hazırlanır. Genellikle 4-6 seans önerilir, seanslar 2-4 hafta aralıklarla yapılır.</p>",
    "id": "1e3dc88e",
    "image": "https://images.pexels.com/photos/5659018/pexels-photo-5659018.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    "title": "Saç Mezoterapisi: Saç Dökülmesine Karşı Etkili Çözüm",
    "slug": "sac-mezoterapisi-sac-dokulmesi",
    "category": "Mezoterapi",
    "related_service": "mezoterapi",
    "date": "2026-02-02",
    "order": 1,
    "excerpt": "Saç mezoterapisi, saç köklerini doğrudan besleyerek dökülmeyi durduran ve yeni saç çıkışını destekleyen kanıtlanmış bir tedavi yöntemidir.",
    "content": "<p>Saç dökülmesi hem kadınları hem erkekleri etkileyen yaygın bir sorundur. <strong>Saç mezoterapisi</strong> bu sorunun çözümünde en etkili medikal tedavilerden biridir.</p><p><strong>Saç mezoterapisinde kullanılan aktif bileşenler:</strong></p><ul><li><strong>Biotin:</strong> Saç keratin yapısını güçlendirir</li><li><strong>Çinko ve Demir:</strong> Saç kökü beslenmesini destekler</li><li><strong>Amino asitler:</strong> Saç protein sentezini artırır</li><li><strong>Vitaminler (B5, B6, B12):</strong> Saç foliküllerinin metabolizmasını hızlandırır</li></ul><p>İlk görüşmede saç ve saç derisi analizi yapılır. Genellikle haftada bir olmak üzere 8-10 seans önerilir. İlk sonuçlar 4-6 hafta içinde gözlemlenir.</p>",
    "id": "85d9f662",
    "image": "https://images.unsplash.com/photo-1767953802241-0c4876b84c2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxoYWlyJTIwbG9zcyUyMHRyZWF0bWVudCUyMHNjYWxwfGVufDB8fHx8MTc3MjE0MzY4N3ww&ixlib=rb-4.1.0&q=85"
  }
];

export const DEFAULT_NEWS = [
  {
    "title": "5. Uluslararası Fonksiyonel Tıp Kongresi",
    "order": 4,
    "date": "2026-03-15",
    "city": "İstanbul",
    "type": "Kongre",
    "description": "Fonksiyonel tıp alanının önde gelen uzmanlarının bir araya geldiği 5. Uluslararası Fonksiyonel Tıp Kongresi, 15-17 Mart 2026 tarihlerinde İstanbul'da düzenlenecektir. Prof. Dr. Nilüfer Yıldırım, \"Otoimmün Hastalıklarda Bağırsak-Beyin Ekseni\" başlıklı sunumuyla kongreye konuşmacı olarak katılacaktır.",
    "image": "https://images.unsplash.com/photo-1718224326658-489bbfbeb2ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwY29uZmVyZW5jZSUyMGNvbmdyZXNzJTIwZXZlbnR8ZW58MHx8fHwxNzcyMTQzODU0fDA&ixlib=rb-4.1.0&q=85",
    "id": "8f188743"
  },
  {
    "title": "European Congress on Integrative Medicine 2026",
    "order": 3,
    "date": "2026-05-20",
    "city": "Viyana",
    "type": "Kongre",
    "description": "Avrupa Entegratif Tıp Kongresi, 20-22 Mayıs 2026 tarihlerinde Viyana'da gerçekleştirilecektir. Prof. Dr. Nilüfer Yıldırım, \"HRV-Guided Stress Management in Chronic Fatigue\" konulu poster sunumuyla katılım sağlayacaktır.",
    "image": "https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "id": "69a2c3ee"
  },
  {
    "title": "Fonksiyonel Tıp Yaklaşımıyla Haşimoto Tedavisinde Umut Veren Sonuçlar",
    "order": 2,
    "date": "2026-02-10",
    "city": "Ankara",
    "type": "Haber",
    "description": "Prof. Dr. Nilüfer Yıldırım'ın kliniğinde uygulanan fonksiyonel tıp protokolleri ile Haşimoto tiroiditi hastalarında antikorların anlamlı düzeyde gerilediği ve hastaların yaşam kalitesinde belirgin iyileşme sağlandığı gözlemlenmiştir. Kişiye özel beslenme planları ve bağırsak restorasyonu tedavisi ile elde edilen bu sonuçlar, alandaki uzmanlar tarafından umut verici bulunmaktadır.",
    "image": "https://images.unsplash.com/photo-1673865641073-4479f93a7776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxoZWFsdGglMjBuZXdzJTIwbWVkaWNhbCUyMHJlc2VhcmNoJTIwc2NpZW5jZXxlbnwwfHx8fDE3NzIxNDM4NTZ8MA&ixlib=rb-4.1.0&q=85",
    "id": "e9463006"
  },
  {
    "title": "HeartMath® Sertifikalı Stres Yönetimi Programı Başladı",
    "order": 1,
    "date": "2026-01-15",
    "city": "Ankara",
    "type": "Haber",
    "description": "Prof. Dr. Nilüfer Yıldırım, HeartMath Institute tarafından verilen Certified Practitioner sertifikasını tamamlayarak kliniğinde bilimsel temelli stres yönetimi programını hayata geçirmiştir. HRV analizi ve HeartMath® teknikleri ile kronik stres, tükenmişlik ve anksiyete şikayetlerine yönelik kişiye özel programlar sunulmaktadır.",
    "image": "https://images.unsplash.com/photo-1659353886114-9aa119aef5aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxoZWFsdGglMjBuZXdzJTIwbWVkaWNhbCUyMHJlc2VhcmNoJTIwc2NpZW5jZXxlbnwwfHx8fDE3NzIxNDM4NTZ8MA&ixlib=rb-4.1.0&q=85",
    "id": "4e36b367"
  }
];

export const DEFAULT_VIDEOS = [
  {
    "order": 10000,
    "id": "rwgH9gvNl8E",
    "title": "Tiroid İlacı Kullanıyorum Ama Hâlâ Kötüyüm… Neden? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 9999,
    "id": "oQsrn82fmjI",
    "title": "Neden Gıda Takviyesi Kullanıyoruz? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 9998,
    "id": "XC9G_Eo0HUw",
    "title": "Sağlıklı Yaşam İçin Para Harcamadan Yapabileceğin En Etkili Adımlar I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 9997,
    "id": "2xCVei2USY4",
    "title": "BT, PET, Röntgen: Kendinizi Nasıl Korursunuz? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 9996,
    "id": "qjbzOkjL47Y",
    "title": "Oksijen Zararlı Olabilir mi? Oksidatif Stres Gerçeği I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 131,
    "id": "ax3HhAbhzS0",
    "title": "Karaciğer Detoksunda Etkili Adımlar: Beslenme, Arınma ve Takviyeler I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 130,
    "id": "RyFvp0JQcy4",
    "title": "Yaşlanmanın Sessiz Tehlikesi: Sarkopeni I Dr. Nilüfer Yıldırım",
    "category": "Mezoterapi",
    "service": "yenileyici-uygulamalar",
    "related_service": "yenileyici-uygulamalar"
  },
  {
    "order": 129,
    "id": "YnByB9GMS-E",
    "title": "Haşimato ve D Vitamini Eksikliği Birlikte Olursa...I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 128,
    "id": "S2Qz2_vFL7M",
    "title": "Alerjinin kök nedeni bağırsakta mı? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 127,
    "id": "3wGswhrkrIY",
    "title": "Safra Kesesi Neden Tıkanıyor? Evde Yapabileceğin Küçük Adımlar I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 126,
    "id": "t1RkARO_P7g",
    "title": "Tiroidi her şey etkiler; Mevsim, Uyku, Hareket I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 125,
    "id": "gTgiy2ept6g",
    "title": "Hızlı kilo kaybı safra taşlarını tetikleyebilir! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 124,
    "id": "KzDiUtr0uoY",
    "title": "DIM ve Östrojen Dengesi I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 123,
    "id": "8S-zl8Zh2V8",
    "title": "Neden Değişemiyoruz? Pratik önerilerle zinciri kırabilirsin! I Dr. Nilüfer Yıldırım",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 122,
    "id": "zuUyKBvo9lA",
    "title": "Karaciğer İçin En Doğal Destek; Sülfürlü Sebzelerin Gücü I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 121,
    "id": "mn2lHkW9MNs",
    "title": "Radyasyon Hasta Eder mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 120,
    "id": "XjURxkT1a0U",
    "title": "Tiroid İlaçları Kemik Eritir mi? Gerçek Mekanizmalar I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 119,
    "id": "nJFDIrD_cWc",
    "title": "Bedenin iyileşme kablosu: Vagus I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 118,
    "id": "vsvxvrzvTfc",
    "title": "Kan Şekerini Dengeleyen 3 Takviye I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 117,
    "id": "il8XRFWCkcA",
    "title": "Testosteronu Doğal Yollarla Artırmak Mümkün mü? I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 116,
    "id": "1ehrtxD3Kxc",
    "title": "Her 10 Gençten 1’i Yüksek Tansiyonlu I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 115,
    "id": "tKMOqPSuKLU",
    "title": "İştahı azaltan iğneler, GLP 1 ve Doğal alternatifler I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 114,
    "id": "EAHMtapFFWs",
    "title": "Tatlıya neden hayır diyemiyorsun? I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 113,
    "id": "O6b392oFf-E",
    "title": "Tokluk kan şekerinin kritik önemi I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 112,
    "id": "BCx_aFoRkNc",
    "title": "Sağlıklı Obezite Mümkün mü? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 111,
    "id": "-igmtaN5ssw",
    "title": "Ferritin Depolarınız Dolu mu? I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 110,
    "id": "7vXsuSOZHjA",
    "title": "Obezite Kanser Riskini Artırır mı? | Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 109,
    "id": "SuVBx2BZ2fE",
    "title": "Tüp bebek tedavisine hazır mısınız? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 108,
    "id": "A3zXrCw_djg",
    "title": "Hatıraların kokusu olur mu? I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 107,
    "id": "C8tMzddT4ic",
    "title": "Meme Kanserinde Gerçek Farkındalık I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 106,
    "id": "fPRkbsFtOkQ",
    "title": "Yapay zeka doktorunuz olabilir mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 105,
    "id": "x4ER05xfB-8",
    "title": "Ergenlikte dürtüsellik normal mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 104,
    "id": "s3J9-7J9lLQ",
    "title": "Otizm ve hiperaktivitede destek tedaviler; SAS metodu I Dr. Nilüfer Yıldırım - Anastasia Ünver",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 103,
    "id": "FaA8dhFkLeg",
    "title": "Otizm ve hiperaktivite nedir? Nasıl tanınır? I Dr. Nilüfer Yıldırım - Anastasia Ünver",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 102,
    "id": "pT2_EUjtrZM",
    "title": "Whey Proteini Kan Şekerini Dengeliyor I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 101,
    "id": "TFNVV3ySXVc",
    "title": "Hareketsizlik Beyni Küçültüyor! I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 100,
    "id": "9hEWyh_mp-0",
    "title": "3 Evrede Tükenmişlik Sendromu I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 99,
    "id": "4orLmH17FDk",
    "title": "Gençler sınav maratonuna hazır mı? I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 98,
    "id": "F6eCYxPcw5c",
    "title": "Kırık Kalp Sendromu I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 97,
    "id": "PXQ7u-nx7Tk",
    "title": "Ağız Kokusundan Kurtulmak Mümkün I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 96,
    "id": "GC6NRArxb9w",
    "title": "Ağız Kokusu Gerçeği I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 95,
    "id": "BRbEgIPdKrs",
    "title": "Sağlıklı Yaşamın Adım Adım Formülü I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 94,
    "id": "w4Vy_BGckG0",
    "title": "İyot takviyesi: Ne zaman faydalı? Ne zaman zararlı? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 93,
    "id": "PlRCCzqNMCc",
    "title": "İyot Eksikliği Efsane mi? Gerçek mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 92,
    "id": "wo6iiKAvsRM",
    "title": "Hipertansiyonu İyileştirmek Sizin Elinizde! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 91,
    "id": "SOq-Hw0QHTU",
    "title": "Gerçekten Aç mısın? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 90,
    "id": "3wMljFUwp0U",
    "title": "Tokum Ama Yerim: Hedonik Açlık I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 89,
    "id": "Pd1-BJ_tqbc",
    "title": "Kreatin Yan Etkisi Efsane mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 88,
    "id": "DPMv0p9eRc0",
    "title": "Sızdıran Bağırsak Sendromu I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 87,
    "id": "CIUp07xmi1Q",
    "title": "Alerji Sandığınız Histamin İntoleransı Olabilir! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 86,
    "id": "9vpmUMdu6ZE",
    "title": "Dopamini Artıran Takviyeler I Dr. Nilüfer Yıldırım",
    "category": "Mezoterapi",
    "service": "yenileyici-uygulamalar",
    "related_service": "yenileyici-uygulamalar"
  },
  {
    "order": 85,
    "id": "aAnxchQX9bg",
    "title": "Haydi Dopamin Yapalım! I Dr. Nilüfer Yıldırım",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 84,
    "id": "2LdXKzaWubc",
    "title": "Kalbin İçindeki Beyin I Dr. Nilüfer Yıldırım",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 83,
    "id": "WU9FK8Epj_Y",
    "title": "Bedenin Patronu Kalp mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 82,
    "id": "TuIXFHEAC2E",
    "title": "Testosteron Tedavisi Güvenli mi?",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 81,
    "id": "CQI6YUTrCo4",
    "title": "Adet sancısı kader değil! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 80,
    "id": "EOOPA5uFG2Y",
    "title": "Adet Öncesi Sendrom (PMS) Psikolojik mi? İyileşir mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 79,
    "id": "pPPwec1mUlQ",
    "title": "Haşimoto’da Östrojen Dominansı I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 78,
    "id": "r8qpMOAVpZ0",
    "title": "Östrojen dominansı tiroidi nasıl etkiliyor? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 77,
    "id": "f9WC6-jD5bg",
    "title": "Nefes Yavaşlarsa Hayat Yavaşlar! I Dr. Nilüfer Yıldırım",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 76,
    "id": "QGun74ASjjY",
    "title": "Video Kaydırmak Nasıl Hasta Ediyor? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 75,
    "id": "D1uGNvHWfVk",
    "title": "İki Sıkı Dost: Testosteron ve Dopamin I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 74,
    "id": "wk6cFVCtu38",
    "title": "Dopamin Hakkında Bilmeniz Gerekenler I Dr. Nilüfer Yıldırım",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 73,
    "id": "TWwO9RbDUtU",
    "title": "Perimenopozun Sinsi Belirtileri I Dr. Nilüfer Yıldırım #perimenopause",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 72,
    "id": "9ZdQgHFi2Mg",
    "title": "Neden Hızlı Yiyorsun? I Dr. Nilüfer Yıldırım",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 71,
    "id": "QJkNJ6cdMeg",
    "title": "Kanserin Gizli Rotasında! Tohum Toprak Hipotezi I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 70,
    "id": "XTUvJCooEf0",
    "title": "Hormon Tedavisi KİME? NEDEN? NASIL? I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 69,
    "id": "FdmmGSwDJic",
    "title": "PPI Kullananlar Dikkat! Kalp Krizi Riski Artıyor mu? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 68,
    "id": "7bKLSWJ-x_U",
    "title": "Kanser Efsaneleri I Her Şey Mi Kanser Yapıyor! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 67,
    "id": "qJpW9pUwPrc",
    "title": "Menopoz Efsanelerini Çürütüyoruz! I Menopoz Efsaneleri 2.Bölüm I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 66,
    "id": "lnNVRu8nxxo",
    "title": "Menopoz Hakkında Doğru Bilinen Yanlışlar! I Menopoz Efsaneleri 1.Bölüm I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 65,
    "id": "2yexZgRjadQ",
    "title": "Beslenmek Suç Değil I Dr. Nilüfer Yıldırım - Dyt. Çağla Çevik",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 64,
    "id": "HdP4YK-Vcjo",
    "title": "SIBO' dan Eliminasyona Diyetler I Dr. Nilüfer Yıldırım - Dyt. Çağla Çevik",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 63,
    "id": "swX--DanblI",
    "title": "Mide Asitini Koru, SIBO Olma! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 62,
    "id": "UsBL-6fa7UQ",
    "title": "Benim Hikayemin Kök Nedeni: Fonksiyonel Dispepsi I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 61,
    "id": "W9szcVGa3p8",
    "title": "Erkekte Prolaktin Neden Yükselir? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 60,
    "id": "9varqpQI0KM",
    "title": "Reflüye En Etkili Çözüm I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 59,
    "id": "w01Vq-sMi80",
    "title": "Gizli Sebep Tiroid Olabilir! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 58,
    "id": "lFANE__9TH0",
    "title": "Otoimmün Hastalık; kendine toleransın var mı? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 57,
    "id": "tEjA8tPe56Q",
    "title": "Tiroid Testleri Doğru Yapılıyor mu? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 56,
    "id": "kKx0ISoBYsY",
    "title": "Sedef Hastalığı (Psöriazis) İyileşir mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 55,
    "id": "2-kEvyo4CDc",
    "title": "Gebelik Haşimoto İçin Riskli mi? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 54,
    "id": "kiemVUla2F4",
    "title": "Andropoz Hakkında Bildikleriniz Doğru mu? I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 53,
    "id": "ORzGJ97I4zI",
    "title": "Hormonları Dengelemek Neden Zor? I Dr. Nilüfer Yıldırım",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 52,
    "id": "VOUe9lTssqs",
    "title": "Kanser Check-up Paketleri Güvenilir mi?",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 51,
    "id": "jSD2TPDHUFM",
    "title": "Mide Asiti Ülser Yapar Mı? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 50,
    "id": "81E1Zci4hks",
    "title": "Çağın Salgını Otoimmün Hastalıklar",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 49,
    "id": "gvv8wX8xRdU",
    "title": "Sezgisel Beslenme ile Diyetlerden Kurtul",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 48,
    "id": "k-KfyZCqZWg",
    "title": "Kendine yatırım yapmak için hasta olmayı bekleme",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 47,
    "id": "sU-3-it2yBY",
    "title": "Fonksiyonel tıp uygulamaları",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 46,
    "id": "O1VkB5hQQiw",
    "title": "Burundan nefes alıp vermek neden önemli?",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 45,
    "id": "GvjeidDYq6I",
    "title": "Tiroid İlacı Kullanırken Bunlara Dikkat! I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 44,
    "id": "z-h8tTtkxbg",
    "title": "Tiroid ilacına rağmen geçmeyen şikayetler I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 43,
    "id": "0cQio6RfgAs",
    "title": "Radyasyonun Zararını Nasıl Azaltırız? I Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 42,
    "id": "1cmZh3x2_38",
    "title": "Fonksiyonel Tıpta İlaç Kulanılır mı? I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 41,
    "id": "fLHInDlf5vQ",
    "title": "Radyasyon Fobisi I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 40,
    "id": "mgOPoTNiPH4",
    "title": "İlaçları Doğru Mu Kullanıyoruz? I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 39,
    "id": "rlxPXL5aQVE",
    "title": "Sakın Diyetle Başlamayın! I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 38,
    "id": "llCowD_dGBU",
    "title": "Hasta Olmanın Gizli Şartları Nelerdir? I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 37,
    "id": "jvLBD9X8agE",
    "title": "Sessiz Tehlikeyi Erken Yakalayın: Meme Kanseri Farkındalığı I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 36,
    "id": "mlRbii0L3Vg",
    "title": "Hormonlar ve Yaşlanma: Genç Kalmanın Bilimsel Yolu I Prof. Dr. Nilüfer Yıldırım",
    "category": "Mezoterapi",
    "service": "yenileyici-uygulamalar",
    "related_service": "yenileyici-uygulamalar"
  },
  {
    "order": 35,
    "id": "WrDOqBZ7xdM",
    "title": "Meme Kanseri Tamamen Önlenebilir mi? Bilimin Söyledikleri... I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 34,
    "id": "lWXQiex5lTU",
    "title": "Fonksiyonel Tıptan Kanser Hastalarına Destek: Neler Mümkün? I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 33,
    "id": "wEsZspcjhzs",
    "title": "Kanserin Sinyalleri I Erken Uyarı I I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 32,
    "id": "0UKac3mFoJ0",
    "title": "Kanser Kaderin Olabilir mi? Kanserin Tarihsel Evrimi I Prof. Dr. Nilüfer Yıldırım",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 31,
    "id": "DthWFebsFfY",
    "title": "Gerçekten Depresyonda mısın?",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 30,
    "id": "CFcnURCrSMk",
    "title": "Gıda Zehirlenmesine DİKKAT",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 29,
    "id": "pgsEXAYXpaQ",
    "title": "Gıda Takviyesi Ne Kadar Süre Kullanılır?",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 28,
    "id": "rr_24EAvHgA",
    "title": "Gıda Takviyesi Aç mı Tok mu Alınmalı?",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 27,
    "id": "-brIMRPp8dI",
    "title": "Gıda Takviyesini Neden Kullanıyoruz?",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 26,
    "id": "rVOwBneSeiY",
    "title": "Tiroid Hormonları Neden Önemli?",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 25,
    "id": "FSrGUe0pDyA",
    "title": "Körük Nefesi Uyandırır",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 24,
    "id": "JlbW34aO2m4",
    "title": "Donma Tepkisi; Stres Yönetimi 13",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 23,
    "id": "RqKulr_v_n4",
    "title": "Vagusu Uyaran Diğer Manevralar; Stres Yönetimi 11",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 22,
    "id": "R1z3Wo7yXeM",
    "title": "Üç boyutlu vagus nefesi; Stres Yönetimi 10",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 21,
    "id": "ffkJIaic6L4",
    "title": "Menopozda Hormon Tedavisi 4",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 20,
    "id": "5SkEGRmKi94",
    "title": "Menopozda Hormon Tedavisi 3",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 19,
    "id": "--xH23iOM4s",
    "title": "Menopozda Hormon Tedavisi 2",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 18,
    "id": "jqH5swQJ2NY",
    "title": "Menopozda Hormon Tedavisi 1",
    "category": "Hormonal Antiaging",
    "service": "hormonal-antiaging"
  },
  {
    "order": 17,
    "id": "ZbjZFS3CYuw",
    "title": "Adrenal Yorgunluk ve Tükenmişlik; stres yönetimi 6",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 16,
    "id": "IOrzQYtib6Q",
    "title": "Rezilyans; stres yönetimi 3",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 15,
    "id": "e7RTigHXM4w",
    "title": "HPA Aksı; Stres yönetimi 2",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 14,
    "id": "cWfcPem1oiE",
    "title": "Sade düşün; stres yönetimi 1",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 13,
    "id": "rgL9XynEKbo",
    "title": "Sade düşün: Kronik Baş Ağrısı",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 12,
    "id": "PgoGF0zKpPw",
    "title": "Sade düşün: Diyafram",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 11,
    "id": "Uf9nqYOY-Rc",
    "title": "Sade düşün: İyileşmeye niyetin var mı?",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 10,
    "id": "M6WhjjRd-hc",
    "title": "Sade düşün: Biyolojik iç saat, sirkadiyen ritim ve melatonin kalibrasyonu",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 9,
    "id": "jUgoWrgaW2k",
    "title": "Prof. Dr. Nilüfer Yıldırım ile Fonksiyonel Tıp Sohbeti. @tv100 Demet Şener’le Biz Bize",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 8,
    "id": "wRsg2VtAY9s",
    "title": "Sade düşün: Rezilyans, Dayanıklılık mı? Esneklik mi?",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 7,
    "id": "-Eog0lt_a9w",
    "title": "Sade düşün: Beyin Dalgaları Alfa, Beta, Theta, Delta",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 6,
    "id": "PwR2s0Rihh4",
    "title": "Sade düşün: Bilinçli Yeme Alışkanlığı",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 5,
    "id": "6uJeqGKTbBU",
    "title": "Sade düşün: Kanseri Önlemek Mümkün mü?",
    "category": "Koruyucu Hekimlik",
    "service": "koruyucu-hekimlik"
  },
  {
    "order": 4,
    "id": "LTaUvj53q7E",
    "title": "Sade düşün: Meditasyon nedir? Ne değildir?",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  },
  {
    "order": 3,
    "id": "Is9IVD-KzxA",
    "title": "Sade düşün: Geçirgen Barsak",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 2,
    "id": "vgj9GE7nByY",
    "title": "Sade düşün: Sezgisel Beslenme",
    "category": "Fonksiyonel Tıp",
    "service": "fonksiyonel-tip"
  },
  {
    "order": 1,
    "id": "dwqByibQcq8",
    "title": "Sade düşün: Sakinleştiren Nefes",
    "category": "Stres Yönetimi",
    "service": "stres-yonetimi"
  }
];
